import { render, staticRenderFns } from "./shipment-details.vue?vue&type=template&id=69ca2a5f&scoped=true"
import script from "./shipment-details.vue?vue&type=script&lang=js"
export * from "./shipment-details.vue?vue&type=script&lang=js"
import style0 from "./shipment-details.vue?vue&type=style&index=0&id=69ca2a5f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69ca2a5f",
  null
  
)

export default component.exports